import { render, staticRenderFns } from "./DeleteCompanyConfirm.vue?vue&type=template&id=30a7f977&"
import script from "./DeleteCompanyConfirm.vue?vue&type=script&lang=js&"
export * from "./DeleteCompanyConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports